import { render, staticRenderFns } from "./CustomerShow.vue?vue&type=template&id=ee5e61aa&scoped=true"
import script from "./CustomerShow.vue?vue&type=script&lang=ts"
export * from "./CustomerShow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee5e61aa",
  null
  
)

export default component.exports